<template>
	<div class="bg-card  mx-auto ">
		<ul class="shadow-box w-full">
			<li class="relative ">
				<div class="relative overflow-hidden transition-all max-h-0 duration-700" :style="isOpen ? `max-height: ${contentRef?.scrollHeight}px` : ''" ref="contentRef" >
					<div class="p-3">
						<slot></slot>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

// Define props and emits
const props = defineProps<{
	modelValue: boolean;
}>();

const emit = defineEmits<{
	(event: 'update:modelValue', value: boolean): void;
}>();

// State for accordion
const isOpen = ref(props.modelValue);
const contentRef = ref<HTMLElement | null>(null);

// Watch for changes in modelValue
watch(
	() => props.modelValue,
	(newValue) => {
		isOpen.value = newValue;
	}
);

// Watch for changes in isOpen and emit to parent
watch(
	() => isOpen.value,
	(newValue) => {
		emit('update:modelValue', newValue);
	}
);
</script>

<style scoped>
/* Add your styles here */
</style>
